export default "__VITE_ASSET__BupqaGzF__"